import { sortObjectArray } from "../util.js";
import { ModalTiteledWindow } from "./modalWindow.js";
import { ModalConfirm } from "./modalConfirm.js";
import { ModalEditAbsence } from "./modalEditAbsence.js";

export class ModalShowAbsenceDetails extends ModalTiteledWindow {

   constructor(app, pupilId, absences, parentModal=false) {
      super();
      this.app = app;
      this.parentModal = parentModal;
      this.addClass('modal-show-absence-details');

      this.user = this.app.dm.getUserSelf();
      this.pupil = this.user.id === pupilId ? this.user : this.app.dm.getUser(pupilId);
      this.setTitle(`MSS-Fehlstunden: ${this.pupil.lastName}, ${this.pupil.firstName}`);

      this.load(absences);      

      setTimeout(() => this.show(), 1);

   }

   async reload() {
      const absences = await this.parentModal.loadAbsences();
      this.load(absences.filter(abs => abs.pupilId === this.pupil.id));
   }

   load(absences) {

      this.absences = absences;

      if (absences.length === 0) {
         this.setBody("Es liegen bisher keine Fehlstunden vor.")
      }
      else {
         sortObjectArray(absences, ['.date', 'lessonTitle']);

         let html = `<table class="bl-2 br-2 bt-2 bb-2">
         <thead>
            <tr>${this.user.type === 'teacher' ? '<th></th>' : ''}<th>Datum</th><th>Fach</th><th>Lehrer</th><th>∑</th><th>entsch.</th><th>Bemerkung</th></tr>
         </thead>
         <tbody>`;

         absences.forEach((item, index) => {
            //console.log(item);
            let teacher = this.app.dm.getUser(item.teacherId);
            if (!teacher) teacher = { short: '?' };
            html += `<tr class="absence" data-index="${index}" data-classreg-id="${item.classRegisterId}" data-pupil-id="${item.pupilId}" data-justified="${item.justified ? 'true' : 'false'}" data-count="${item.cnt}" data-note="${item.note}">
               ${this.user.type === 'teacher' ? '<td class="delete"><i class="icon-trash"></i></td>' : ''}
               <td>${Date.fromString(item.date).toGermanDate(true)}</td>
               <td>${item.course}</td>
               <td>${teacher.short}</td>
               <td class="count fw-bold">${item.cnt}</td>
               <td class="justified ta-center">${item.justified ? '<span class="color-green">✔</span>' : '<span class="color-red">✖</span>'}</td>
               <td class="note">${item.note}</td>
               </tr>`
         });

         html += '</tbody></table>';

         this.setBody(html);

         this.panel.querySelectorAll('table tr.absence').forEach(elTd => elTd.onclick = (event) => {

            let elTr = event.target.closest('tr');

            new ModalEditAbsence(
               `Fehlstunden von ${this.pupil.lastName}, ${this.pupil.firstName}`,
               6,
               parseInt(elTr.dataset.count),
               elTr.dataset.note,
               (count, note) => {
                  const data = {
                     action: 'classreg-absence-save',
                     classregId: parseInt(elTr.dataset.classregId),
                     pupilId: parseInt(elTr.dataset.pupilId),
                     count: count,
                     note: note
                  };
                  this.app.dm.sinRequest(data).then((response) => {
                     if (response.data) {
                        this.app.dm.getClassRegisterItem({ id: data.classregId }).then(item => {
                           if (item) {
                              const abs = item.absent.find(a => a.id === data.pupilId);
                              if (!abs) throw "Der Schüler wurde nicht gefunden";
                              abs.justified = data.justified;
                              this.app.dm.saveClassRegister(item).then(() => this.app.classReg.redrawBuffer());
                           }
                        });
      
                        elTr.querySelector('td.count').innerHTML = response.data.value + '';
                        elTr.dataset.count = response.data.count;
                        elTr.querySelector('td.note').innerHTML = response.data.note + '';
                        elTr.dataset.note = response.data.note;                        
                     }
                  }).catch(error => this.app.handleError(error));
               }
           );

         });

         this.panel.querySelectorAll('table td.justified').forEach(elTd => elTd.onclick = (event) => {
            event.stopPropagation()
            let elTr = event.target.closest('tr');
            const data = {
               action: 'classreg-absence-justify',
               classregId: parseInt(elTr.dataset.classregId),
               pupilId: parseInt(elTr.dataset.pupilId),
               justified: elTr.dataset.justified !== "true"
            };
            this.app.dm.sinRequest(data).then((response) => {
               if (response.data) {
                  this.app.dm.getClassRegisterItem({ id: data.classregId }).then(item => {
                     if (item) {
                        const abs = item.absent.find(a => a.id === data.pupilId);
                        if (!abs) throw "Der Schüler wurde nicht gefunden";
                        abs.justified = data.justified;
                        this.app.dm.saveClassRegister(item).then(() => this.app.classReg.redrawBuffer());
                     }
                  });

                  elTr.querySelector('td.justified').innerHTML = response.data.justified ? '<span class="color-green">✔</span>' : '<span class="color-red">✖</span>';
                  elTr.dataset.justified = response.data.justified ? 'true' : 'false';
               }
            }).catch(error => this.app.handleError(error));
            
         });

         this.panel.querySelectorAll('table td.delete').forEach(elTd => elTd.onclick = (event) => {
            event.stopPropagation()
            let elTr = event.target.closest('tr');
            const absence = this.absences[parseInt(elTr.dataset.index)];

            new ModalConfirm(
               `Soll Fehlzeit ${Date.fromString(absence.date).toGermanDate(true)}, ${absence.lessonTitle} (${this.app.dm.getUser(absence.teacherId).short}) wirklich gelöscht werden?`,
               async (confirmed) => {
                  if (confirmed) {
                     const data = {
                        action: 'classreg-absence-delete',
                        classregId: parseInt(elTr.dataset.classregId),
                        pupilId: parseInt(elTr.dataset.pupilId)
                     };
                     this.app.dm.sinRequest(data).then((response) => {
                        this.app.dm.getClassRegisterItem({ id: data.classregId }).then(item => {
                           item.absent = item.absent.filter(a => a.id !== data.pupilId);
                           this.app.dm.saveClassRegister(item).then(() => this.app.classReg.redrawBuffer());
                           this.reload();
                        });
                     }).catch(error => this.app.handleError(error));
                  }
               }
            );
         });

      }

   }

}
